<template>
  <div class="h100vh-140">
    <div class="h-toolbarBg">
      <ejs-toolbar>
        <e-items>
          <e-item prefixIcon='icon hero-icon hero-icon-add' :tooltipText='$t("Security.add")' :click="addTimePolicyDialog"></e-item>
          <e-item prefixIcon='icon hero-icon hero-icon-edit' :tooltipText='$t("Security.modify")' :click="editTimePolicyDialog"></e-item>
          <e-item prefixIcon='icon hero-icon hero-icon-remove' :tooltipText='$t("Security.delete")' :click="delTimePolicyFunc"></e-item>
          <e-item prefixIcon='icon hero-icon hero-icon-refresh' :tooltipText='$t("Common.refresh")' :click="getPolicyList"></e-item>
        </e-items>
      </ejs-toolbar>
      <div class="h-inputBox">
        <input class="e-input" :placeholder='$t("Security.Strategy.name")' @keyup.enter="filterPolicyList" v-model="keyString" maxLength='20'/>
      </div>
    </div>
    <div class="h100-40 noPage">
      <ejs-grid ref='grid' height='100%'>
        <e-columns>
          <e-column field="name" :headerText='$t("Security.timeStrategy")' width="120" textAlign="Center" clipMode="EllipsisWithTooltip"></e-column>
          <e-column field="startDate" :headerText='$t("Security.Strategy.startDate")' :format="dateFormat" type='date' width="100" textAlign="Center"></e-column>
          <e-column field="endDate" :headerText='$t("Security.Strategy.endDate")' :format="dateFormat" type='date' width="100" textAlign="Center"></e-column>
          <e-column field="time" :headerText='$t("Security.Strategy.time")' width="120" textAlign="Center"></e-column>
          <e-column field="week" :headerText='$t("Security.Strategy.weekday")' :formatter="convertWeek" width="170" textAlign="Center"></e-column>
          <e-column field="des" :headerText='$t("Security.User.desc")' width="150" textAlign="Center" clipMode="EllipsisWithTooltip"></e-column>
        </e-columns>
      </ejs-grid>
    </div>
    <CustomDialog ref="policyDialog" v-bind:element="policyDialog.element" v-bind:styles="policyDialog.styles">
      <template v-slot:dialog-content>
        <TimePolicyCom ref="timePolicy" @childProps="setChildProps"></TimePolicyCom>
      </template>
    </CustomDialog>
  </div>
</template>

<script>
import CustomDialog from "../../common/CustomDialog";
import TimePolicyCom from "./TimePolicyCom";
import { Filter } from "@syncfusion/ej2-vue-grids"
import { EventBus } from "../../../plugins/eventBus";

export default {
  name: "timeStrategy",
  data() {
    return {
      originData: [],
      keyString: "",
      policyDialog: {
        element: {
          // target: "#app",
          isClose: true,
          refName: "policyDia",
          buttonGroup: [
            {
              click: this.dialogHide,
              buttonModel: {
                content: `${this.$t("Common.cancel")}`,
              }
            },
            {
              click: this.confirm,
              buttonModel: {
                content: `${this.$t("Common.ok")}`,
                cssClass: 'primary-btn'
              }
            }
          ],
          title: `${this.$t("Security.addTimePolicy")}`
        },
        styles: {
          width: "810px",
          height: "auto",
          model: true,
          visible: false
        }
      },
      addOrEdit: 0, // 0 add or 1 edit
      childProps: {},
      dateFormat: {
        type: 'date', format: 'yyyy/MM/dd'
      },
      weekStatic: {
        '1': `${this.$t("Security.Strategy.monday")}`,
        '2': `${this.$t("Security.Strategy.tuesday")}`,
        '3': `${this.$t("Security.Strategy.wednesday")}`,
        '4': `${this.$t("Security.Strategy.thursday")}`,
        '5': `${this.$t("Security.Strategy.friday")}`,
        '6': `${this.$t("Security.Strategy.saturday")}`,
        '7': `${this.$t("Security.Strategy.sunday")}`,
      }
    };
  },
  methods: {
    addTimePolicyDialog() {
      this.addOrEdit = 0;
      this.policyDialog.element.title = `${this.$t("Security.addTimePolicy")}`;
      this.$refs.timePolicy.bindValidate();
      this.$refs.policyDialog.show();
    },
    delTimePolicyFunc(){
      let record = this.getRecord();
      if (record == null) {
        return null;
      }
      if (record[0]['strategyId'] === '3'){
        this.eventEmit('warning', `${this.$t("Security.defaultPolicyNotDel")}`);
        return null;
      }
      this.$layer.confirm({
        msg: `${this.$t('Common.tips.confirmTip')}`,
        btn1: {
          msg: `${this.$t('Common.cancel')}`
        },
        btn2: {
          msg: this.$t('System.confirm'),
          func: this.delTimePolicy
        }
      });
    },
    convertWeek(args, row) {
      let weekStr = row.week
      if (!!row.week) {
        let weekArr = row.week.split(",")
        weekArr = weekArr.sort((a,b) => {
          return parseInt(a)-parseInt(b);
        }).map(item => {
          return this.weekStatic[item];
        })
        weekStr = weekArr.join(",")
      }
      return weekStr;
    },
    delTimePolicy() {
      let record = this.getRecord();
      if (record == null) {
        return null;
      }
      if (record[0]['strategyId'] === '3'){
        this.$parent.showToast('warning',`${this.$t("Security.defaultPolicyNotDel")}`);
        return null;
      }
      const url = "/lte/ems/strategy/deleteTimeStrategy";
      const params = [];
      record.forEach(item => {
        params.push(item.strategyId);
      }
      );
      this.axios.post(url, params).then(response => {
        if (response && response.status === 200 && response.data === true) {

          this.getPolicyList();
          this.eventEmit('success', `${this.$t("Common.tips.success")}`);
        } else {
          
          this.eventEmit('error', `${this.$t('Common.tips.failure')}`);
        }
      });
    },
    editTimePolicyDialog() {
      let record = this.getRecord();
      if (record == null) {
        return null;
      }
      if (record[0]['strategyId'] === '3'){
        this.eventEmit('warning', `${this.$t("Security.defaultPolicyNotEdit")}`);
        return null;
      }
      this.addOrEdit = 1;
      this.policyDialog.element.title = `${this.$t("Security.editTimePolicy")}`;
      
      this.$refs.timePolicy.bindValidate();
      this.$refs.timePolicy.edit(record[0]);
      this.$refs.policyDialog.show();
    },
    filterPolicyList() {
      let filterList = [];
      let key = this.keyString;
      if (key.trim()=='') {
        filterList = this.originData;
      }else{
        this.originData.forEach((d, i) => {
          if (d.name.indexOf(key)!=-1) {
            filterList.push(d);
          }
        });
      }
      this.$refs.grid.ej2Instances.dataSource = filterList;
    },
    getPolicyList() {
      const url = "/lte/ems/strategy/findTimeStrategy";
      const params = {
        // strategyName: this.keyString
      };
      this.axios.get(url, { params }).then(response => {
        const result = response.data;
        const showRe = [];
        result.forEach(e => {
          const item = {};
          item.strategyId = e.strategyId;
          item.strategyType = e.strategyType;
          item.startDate = e.items["tss.startDate"];
          item.endDate = e.items["tss.endDate"];
          item.des = e.items["tss.des"];
          item.time = e.items["tss.startTime"] + "~" + e.items["tss.endTime"];
          item.name = e.items["tss.name"];
          item.week = e.items["tss.week"];
          showRe.push(item);
        });
        this.originData = showRe;
        this.$refs.grid.ej2Instances.dataSource = showRe;
      });
    },
    dialogHide() {
      this.$refs.policyDialog.clear();
      this.$refs.policyDialog.close();
    },
    async confirm() {
      const validate = this.$refs.timePolicy.validate();
      if (!validate) {
        return null;
      }
      const child = this.childProps;
      if(child.dateRead === 1 && child.timeRead === 1 && child.weekRead === 1){
        this.eventEmit('warning', `${this.$t("Security.dateNotNull")}`);
        return null;
      }
     
      if (child.dateRead === 0) {
        if (child.startDate == null || child.endDate == null || child.startDate === '' || child.endDate === '') {
          this.eventEmit('warning', `${this.$t("Security.dateNotNull")}`);
          return null;
        }
        if (child.startDate.getTime() > child.endDate.getTime()) {
          this.eventEmit('warning', `${this.$t("Security.dateCompare")}`);
          return null;
        }
      } else {
        child.startDate = '';
        child.endDate = '';
      }
      if (child.timeRead === 0) {
        if (child.startTime == null || child.endTime == null || child.startTime === '' || child.endTime === '') {
          this.eventEmit('warning', `${this.$t("Security.timeNotNull")}`);
          return null;
        }
        if (Date.parse('1970/1/1 ' + child.startTime) > Date.parse('1970/1/1 ' + child.endTime)) {
          this.eventEmit('warning', `${this.$t("Security.timeCompare")}`);
          return null;
        }
      } else {
        child.startTime = '';
        child.endTime = '';
      }
      if (child.weekRead === 0) {
        if (child.week === '') {
          this.eventEmit('warning', `${this.$t("Security.weekNotNull")}`);
          return null;
        }
      } else {
        child.week = '';
      }
      let url = "";
      const items = {
        "tss.endDate": this.convertDate(child.endDate),
        "tss.des": child.description,
        "tss.startTime": child.startTime,
        "tss.name": child.policyName,
        "tss.endTime": child.endTime,
        "tss.week": child.week,
        "tss.startDate": this.convertDate(child.startDate)
      };
      const params = {
        items: items,
        strategyType: 3
      };
      if (this.addOrEdit === 0) {
        const exist = await this.strategyName(child.policyName);
        if (exist) {
          return null;
        }
        url = "/lte/ems/strategy/addTimeStrategy";
      } else {
        url = "/lte/ems/strategy/editStrategy";
        params.strategyId = this.getRecord()[0].strategyId;
      }
      let That = this;
      this.axios.post(url, params).then(response => {
        this.$refs.policyDialog.clear();
        this.$refs.policyDialog.close();
        if (response.data) {
          That.eventEmit('success', `${this.$t("Common.tips.success")}`);
        } else {
          That.eventEmit('error', `${this.$t("Common.tips.failure")}`);
        }
        this.getPolicyList();
      });
    },
    async strategyName(policyName){
      const url = "/lte/ems/strategy/findTimeStrategy";
      const params = {
        strategyName: policyName
      };
      let exist = new Boolean();
      await this.axios.get(url, { params }).then(response => {
        if (response.data.length != 0) {
          this.eventEmit('warning', `${this.$t("Security.strategyNameExist")}`);
          exist = true;
        } else {
          exist = false;
        }
      });
      return exist;
    },
    getRecord() {
      let record = this.$refs.grid.ej2Instances.getSelectedRecords();
      if (record == null || record == "") {
        this.eventEmit('warning', `${this.$t("Common.tips.selectOne")}`);
        return null;
      }
      return record;
    },
    setChildProps(data) {
      this.childProps = data;
    },
    copyDeep(data) {
      let returnData = JSON.parse(JSON.stringify(data));
      return returnData;
    },
    eventEmit(type, content) {
      EventBus.$emit('toast', {type: type, content: content})
    },
    convertDate(date){
      let result = '';
      if (!!date) {
        let m = date.getMonth()+1;
        let d = date.getDate();
        result = date.getFullYear() + '-' + (m < 10?('0' + m):m) + '-' + (d < 10?('0'+d):d);
      }
      return result;
    }
  },
  components: {
    CustomDialog,
    TimePolicyCom
  },
  mounted() {
    this.getPolicyList();
  },
  provide: {
    grid: [Filter]
  }
};
</script>
